<template>
    <h1>Spite: Fractured Shards</h1>
    <div class="Spite">
        <iframe width="560" height="315" src="https://www.youtube-nocookie.com/embed/f5eYORr78Vc" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
        <p>
            This project was the first project using our own engine, which we decided to call Eggine.
            I focused a lot on engine and rendering in this project, which I found very interesting
            and was something I was eager to continue with in following projects.
        </p>
        <p>
            In this project I focused on implementing the ECS-system, the particle system, Deferred rendering and various
            other rendering features. I also dabbled in some optimizations using SIMD, although this was mostly code from
            stack overflow.
        </p>
        <img src="/ParticleEditor1.png" id="particleEditor1">
    </div>
</template>

<style scoped>
.Spite{
  margin-left: 20%;
  margin-right: 20%;
}
#particleEditor1{
    width: 60%;
    height: 60%;
}
</style>